import {
  boolean,
  define,
  func,
  Infer,
  number,
  object,
  optional,
  record,
  string,
} from 'superstruct';
import { Url } from '../types/commonTypes';
import { SimulateConfigSchema } from './simulate';
import { SimulateSpecialsConfigSchema } from './simulateSpecials';
import {
  SwipeGamesConfigSchema,
  SwipeGamesConfig as SwipeGamesConfigType,
} from './swipe';
import { MiniGamesConfigSchema } from './mini';

export type OnEventHandler = (
  eventName: string,
  payload?: Record<string, unknown>,
) => void;

export const OnEventHandlerSchema = define<OnEventHandler>(
  'OnEventHandler',
  (value) => typeof value === 'function',
);

export const LocaleConfigSchema = object({
  language: string(),
  translations: record(string(), record(string(), string())),
});

export const LoggingConfigSchema = object({
  enableLogger: boolean(),
  transmit: object({
    level: string(),
    send: func(),
  }),
});

export const OTPResponseSchema = object({
  data: string(),
  status: number(),
  error: object({
    code: number(),
    message: string(),
  }),
});

export const OTPConfigSchema = object({
  callbackFn: func(),
  remoteApiEnable: boolean(),
  remoteApiEndPoint: optional(Url),
  requestHeaders: object(),
  routeParams: object(),
  queryString: object(),
});

export const LogiSDKConfigSchema = object({
  tenantId: string(),
  otpConfig: OTPConfigSchema,
  locale: optional(LocaleConfigSchema),
  logging: optional(LoggingConfigSchema),
  onEvent: optional(OnEventHandlerSchema),

  // swipeGames
  enableSwipeGames: optional(boolean()),
  swipeGames: optional(SwipeGamesConfigSchema),

  // miniGames
  enableMiniGames: optional(boolean()),
  miniGames: optional(MiniGamesConfigSchema),

  // simulate
  enableSimulate: optional(boolean()),
  simulate: optional(SimulateConfigSchema),

  // simulateSpecials
  enableSimulateSpecials: optional(boolean()),
  simulateSpecials: optional(SimulateSpecialsConfigSchema),
});

export type LoggingConfig = Infer<typeof LoggingConfigSchema>;
export type OTPConfig = Infer<typeof OTPConfigSchema>;

export type LogiSDKConfig = Omit<
  Infer<typeof LogiSDKConfigSchema>,
  'swipeGames'
> & {
  swipeGames?: SwipeGamesConfigType;
};
